
//export var var1:string = 'http://localhost:4000';
export var var1:string = '';